
import angular from "angular";

import DependencyListBuilder from "../../utility/DependencyListBuilder";

import TrackingCalendarViewConfiguration from "./TrackingCalendarViewConfiguration";

const trackingCalendarViewModuleDependencies = DependencyListBuilder([
    TrackingCalendarViewConfiguration.dependencies
]);

export default angular
    .module(
        "trackerbase-app.views.tracking-calendar-view",
        trackingCalendarViewModuleDependencies
    )
    .config(TrackingCalendarViewConfiguration)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/TrackingCalendarView.js
// module id = JMg6
// module chunks = 1